<template>
	<div v-if="isActive || isSelected" class="list-group-item col-xs-12" :class="{ active: isSelected && isActive}">
		<div class="col-xs-12 pl-0 pr-0">
			<label class="radio-checkbox-label radio-inline col-xs-12 pr-0" @click.prevent>
				<input class="checkbox" type="radio" :checked="isSelected" />
				<span class="checkbox-custom" >
					<span v-if="isSelected && isActive" class="checkbox-dot" />
					<span v-else-if="isSelected && ! isActive" class="glyphicon glyphicon-ok ok-mark" />
				</span>
				<span style="font-weight: bold;" class="ml-3">{{ store.name }}
					<span v-if="storeDistance && isActive" class="store-distance sub-title" style="font-weight: normal;">{{ storeDistance }}</span>
					<span v-else-if="isActive" class="sub-title" style="font-weight: normal; font-size: 12px;">{{ store.city }}</span>
				</span>
				<span v-if="isActive" class="pull-right" style="font-weight: bold;">0 kr</span>
				<span v-else class="pull-right" style="font-weight: bold;">Ändra</span>
			</label>
		</div>
		<div class="col-xs-9 col-md-10 stock">
			<span :class="['stock-icon', stockClass]" />
			<p class="sub-title">
				{{ recalculateStock }}
				<span v-if="storeMessage" class="highlight">
					{{ storeMessage }}
				</span>
				<span v-if="hastyPickup" class="highlight">
					{{ hastyPickup }}
				</span>
			</p>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import stockUtils from 'utils/stock';
import { getStore } from 'datastore/i18n';
import { t } from 'datastore/i18n';
import { blackWeek } from 'staticData';

export default {
	data() {
		return {
			stockText: '',
			stockTextExtra: '',
			stockStatus: 0,
			stockClass: {
				'stock-icon-instock': true,
			},
			fruangen: 16,
		};
	},
	props: {
		selectedStoreId: {
			type: Number,
			required: false,
		},
		isActive: {
			type: Boolean,
			required: true,
		},
		storeId: { required: true },
		cartRows: { required: true },
		storeDistance: { required: false, default: null },
	},
	methods: {
		tc: t.prefix('CHECKOUT.STOCK'),
	},
	computed: {
		recalculateStock () {
			let release = null;
			for (const row of this.cartRows) {
				const r = row.product.release;
				if (! release || r.timestamp > release.timestamp) {
					release = r;
				}
			}
			const ret = stockUtils.calculateStockStatus(this.storeId, null, this.userSettings, release, 'small', [], this.cartRows);

			this.stockClass = ret.stockClass;
			this.stockStatus = ret.stockStatus;

			// Remove stock message from uppsala if CC isnt activated
			if (this.storeMessage && this.storeId === this.uppsala) {
				return '';
			}

			return ret.stockText == 'Ej i lager' ? this.tc('STORE_OUT_OF_STOCK') : ret.stockText ;
		},
		store () {
			return getStore(this.storeId);
		},
		isSelected () {
			return this.selectedStoreId === this.storeId;
		},
		storeMessage () {
			const today = new Date();
			let storeMessage = false;

			switch (this.storeId) {
				case this.fruangen:
					const fruangenStop = new Date('2025/12/22 00:00:02');
					if (today > fruangenStop) {
						storeMessage = 'Butiken upphör 11/1.';
					}
					break;
				default:
					break;
			}

			return storeMessage;
		},
		hastyPickup () {
			let hastyMessage = false;
			// endBlackweek including Christmas dates 2025
			const today = new Date();
			const beginningBlackweek = new Date(blackWeek.start);
			const endBlackweek = new Date(blackWeek.endHastyPickup);
			if (today >= beginningBlackweek && today <= endBlackweek && this.recalculateStock === 'Redo att hämtas direkt!') {
				if (this.userLevel >= 17) {
					hastyMessage = 'Hämta senast inom 3 dagar!';
				} else {
					hastyMessage = 'Hämta senast inom 2 dagar!';
				}
			}
			return hastyMessage;
		},
		...mapState({
			userSettings: state => state.userSettings,
			userLevel: state => state.user.rankLevel,
		}),
	},
	watch: {
		stockStatus (to) {
			/**
			 * if stockStatus > 1, then product is either out of stock in store and cl
			 * and we dont know when it will be shipped, or it can never be shipped.
			 */
			this.$emit('update:stockStatus', to === 1);
		},
	}
};
</script>
